"use client";

import SunIcon from "@/assets/icons/SunIcon";
import classes from "./RadioButton.module.scss";
import MoonIcon from "@/assets/icons/MoonIcon";
import CircleWithCurvedLine from "@/assets/icons/CircleWithCurvedLine";
import { useEffect, useState } from "react";
import { useTheme } from "../ThemeProvider/ThemeProvider";

type Props = {
  className?: string;
};

const RadioButton = ({ className }: Props) => {
  const [darkActive, setDarkActive] = useState(false);

  const { setTheme } = useTheme();

  useEffect(() => {
    const mode = localStorage.getItem("mode");

    if (!mode || mode === "light") {
      document.body.style.setProperty("--bg-color", "white");

      document.documentElement.setAttribute("data-theme", "light");

      setDarkActive(false);
    } else {
      document.body.style.setProperty("--bg-color", "black");

      document.documentElement.setAttribute("data-theme", "dark");

      setDarkActive(true);
    }
  }, []);

  const radioBtnClickHandler = () => {
    setDarkActive((prevState) => !prevState);
  };

  useEffect(() => {
    if (darkActive) {
      document.documentElement.setAttribute("data-theme", "dark");
      document.body.style.setProperty("--bg-color", "black");
      setTheme("dark");
      localStorage.setItem("mode", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
      document.body.style.setProperty("--bg-color", "white");
      setTheme("light");
      localStorage.setItem("mode", "light");
    }
  }, [darkActive, setTheme]);

  return (
    <div
      className={`${classes["radio-btn-container"]} ${
        className ? className : ""
      }`}
      onClick={radioBtnClickHandler}
    >
      <SunIcon width="11.3" height="11.3" />
      <MoonIcon width="11.3" height="11.3" />

      <div
        className={
          darkActive
            ? `${classes["ball-container"]} ${classes["ball-container-animate-towards-right"]}`
            : `${classes["ball-container"]} ${classes["ball-container-animate-towards-left"]}`
        }
      >
        <CircleWithCurvedLine />
      </div>
    </div>
  );
};

export default RadioButton;
